import { makeAutoObservable, runInAction } from 'mobx';
import { number } from 'yup';
import { history } from "../..";
import agent from '../api/agent';
import { Degree, SGPersona, SGPersonaFormValues } from '../models/SGPersona';

export default class SGPersonaStore {

    SGPersonaRegistry = new Map<string, SGPersona>();
    DegreeRegistry = new Map<number, Degree>();

    selectedSGPersona: SGPersona | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
    recarga = false
    idUser = ""

    constructor() {
        makeAutoObservable(this)
    }

    get SGPersonaByName() {
        return Array.from(this.SGPersonaRegistry.values()).sort((a, b) => 
            (a.nombres > b.nombres ? 1 : -1));
    }

    loadSGPersonas = async () => {
        this.loadingInitial = true;
        try {
            const SGPersonas = await agent.SGPersonas.list();
            SGPersonas.forEach(SGPersona => {
                this.setSGPersona(SGPersona);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }
    delegacionValido = (dele: number) =>{
        if(!dele ){
            return false;
        }
    }
    dpiValido = (cui:string) =>{
        if (!cui) {
            return true;
        }
    
        var cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/;
    
        if (!cuiRegExp.test(cui)) {
            return false;
        }
    
        cui = cui.replace(/\s/, '');
        var depto = parseInt(cui.substring(9, 11), 10);
        var muni = parseInt(cui.substring(11, 13));
        var numero:any = cui.substring(0, 8);
        var verificador = parseInt(cui.substring(8, 9));
        
        var munisPorDepto = [ 
            17, 
            8, 
            16, 
            16, 
            13, 
            14, 
            19, 
            8, 
            24, 
            21, 
            9, 
            30, 
            32, 
            21, 
            8, 
            17, 
            14, 
            5, 
            11, 
            11, 
            7, 
            17 
        ];
        
        if (depto === 0 || muni === 0)
        {
            return false;
        }
        
        if (depto > munisPorDepto.length)
        {
            return false;
        }
        
        if (muni > munisPorDepto[depto -1])
        {
            return false;
        }

        var total = 0;
        
        for (var i = 0; i < numero.length; i++)
        {
            total += numero[i] * (i + 2);
        }
        
        var modulo = (total % 11);
        
        return modulo === verificador;
    }

    nitValido = (nit:string) => {
        if (!nit) {
            return false;
        }
    
        var nitRegExp = new RegExp('^[0-9]+(-?[0-9kK])?$');
    
        if (!nitRegExp.test(nit)) {
            return false;
        }
    
        nit = nit.replace(/-/, '');
        var lastChar = nit.length - 1;
        var number = nit.substring(0, lastChar);
        var expectedCheker = nit.substring(lastChar, lastChar + 1).toLowerCase();
    
        var factor = number.length + 1;
        var total = 0;
    
        for (var i = 0; i < number.length; i++) {
            var character = number.substring(i, i + 1);
            var digit = parseInt(character, 10);
    
            total += (digit * factor);
            factor = factor - 1;
        }
    
        var modulus = (11 - (total % 11)) % 11;
        var computedChecker = (modulus == 10 ? "k" : modulus.toString());
    
        return expectedCheker === computedChecker;
    }

    loadSGPersona = async (id: string) => {
        let SGPersona = this.getSGPersona(id);
        if (SGPersona) {
            this.selectedSGPersona = SGPersona;
            return SGPersona;
        } else {
            this.loadingInitial = true;
            try {
                SGPersona =  await agent.SGPersonas.details(id);
                this.setSGPersona(SGPersona);
                runInAction(() => {
                    this.selectedSGPersona = SGPersona;
                })
                this.setLoadingInitial(false);
                return SGPersona;

                
            } catch (error) {
                this.setLoadingInitial(false);
                return SGPersona;
            }
        }
    }

    private setSGPersona = (SGPersona: SGPersona) => {
        
        this.SGPersonaRegistry.set(SGPersona.dpi, SGPersona);
    }

    private getSGPersona = (UserID: string) => {
        return this.SGPersonaRegistry.get(UserID);
    }

    private setDegree = (DegreeInstance : Degree) => {
        return this.DegreeRegistry.set(DegreeInstance.id, DegreeInstance);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }


    createSGPersona = async (SGPersona: SGPersonaFormValues) => {
//        const user = store.userStore.user;
        try {
            await agent.SGPersonas.create(SGPersona);
            runInAction(() => {
                this.selectedSGPersona = SGPersona;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    getGrades = async (cui: string) => {
        this.loadingInitial = true;

        try {                    
            const lstGrades = await agent.CATCursos.getGrades(cui);
            lstGrades.forEach(GradeItem => {
                this.setDegree(GradeItem);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
        
    }

    updateSGPersona = async (SGPersona: SGPersonaFormValues) => {
        try {
            this.loading = true;
            await agent.SGPersonas.update(SGPersona)
            runInAction(() => {
                if (SGPersona.dpi) {
                    let updateSGPersona = {...this.getSGPersona(SGPersona.dpi), ...SGPersona}
                    this.SGPersonaRegistry.set(SGPersona.dpi, updateSGPersona as SGPersona);
                    this.selectedSGPersona = updateSGPersona as SGPersona   
                    this.loading = false;  
                } 
            } )
        } catch (error) {
            this.loading = false;
        }
    }

    deleteSGPersona = async (dpi: string) => {
        this.loading = true;
        try {
            await agent.SGPersonas.delete(dpi);
            runInAction(() => {
                this.SGPersonaRegistry.delete(dpi);
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }


}